import {all, call, put, takeLatest, select } from 'redux-saga/effects'
import * as api from '../lib/api';
import * as action from '../constants/actionTypes';
import { push } from 'connected-react-router'

export function* signUp(signUpAction : any) {
 try {
  const state = yield select();

  yield call(() => api.signUp(signUpAction.info, state.tool));
  yield put({type: action.SIGN_UP_SUCCESS});
 } catch (error) {
    yield put({ type: action.SIGN_UP_FAILURE, errorMessage: 'There has been an error, please try again.' });
 }
}

export function* toggleWalkthroughComplete(isComplete: boolean) {
   yield put(push(isComplete ? '/' : '/walkthrough'))
}

export function* rootSaga() {
 yield all([
    takeLatest<any>(action.SIGN_UP, signUp),
    takeLatest<any>(action.TOGGLE_WALKTHROUGH_COMPLETE, toggleWalkthroughComplete)
 ]);
}

export default rootSaga;
